import { createElement } from "rax";
import * as Dinamic from "@ali/dinamic";
import { TextView } from "@ali/dinamic-views-icbu-fork";
import {setIndexMapContext} from '../utils/index';

class ALITextView extends TextView {
  _supportHTMLStyle = false;

  supportHTMLStyle(propValue) {
    this._supportHTMLStyle = propValue;
  }

  componentDidMount() {
    if (this.$span && this.$span.children) {
      for (const el of this.$span.children) {
        if (el.tagName.toLowerCase() === 'img') {
          el.style.height = this.fontSize;
          el.style.marginLeft = '2px';
          el.style.marginRight = '2px';
        }
      }
    }
  }

  renderView() {
    return (
      <span
        style={this.getStyles('font')}
        dangerouslySetInnerHTML={{ __html: this.textContent }}
        ref={$span => this.$span = $span}
      >
      </span>
    );
  }
  render() { 
    const props = this.props;

    // 渲染前绑定上下文，使所有控件均可在渲染结束后调用 calc
    setIndexMapContext.call(this);
    const {htmlHeading} = props;
    let TagComponent = "div";
    if(htmlHeading){
      TagComponent = htmlHeading;
    }
    
    return (
      <TagComponent
        key={props._id}
        view-name={this.getViewName()}
        style={this.getStyles()}
        {...this.getAttrs()}
      >
        {this.renderView && this.renderView(props)}
      </TagComponent>
    );
  }
}

Dinamic.registerView("ALITextView", ALITextView);

export default ALITextView;